module.exports = __webpack_public_path__ + "585d7ad5dce517089ef473b9dc861837.pdf";